module.exports = __webpack_public_path__ + "static/media/Settings-selected-icon.39053e5d.svg";